import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { CellProps } from 'react-table';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { IOrderRemainingHoursReport } from 'src/types/orderRemainingHoursReport';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';
import { numberWithCommas } from '../../../../../../helpers/format';
import { ICase } from '../../../../../../types/case';
import OrderEnum from '../../../../../../enumerables/order-enum';
import { getValFromEnum } from '../../../../../../components/redux-form/utils/dropdown-values';
import dropDownFilter from '../../../../../../components/react-table/filters/dropdown-filter';
import { IOrder } from '../../../../../../types/order';
import dropdownFilter from '../../../../../../components/react-table/filters/dropdown-filter';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';
import dateFilter from '../../../../../../components/react-table/filters/date-filter';
import dropdownOrderFilter from '../../../../../../components/react-table/filters/dropdown-order-filter';

interface Props {
    data: Paginated<IOrderRemainingHoursReport>;
    students: SelectObject[];
    districts: SelectObject[];
    vendors: SelectObject[];
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    serviceTypes: SelectObject[];
}

// const typeEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
// const caseTypes: SelectObject[] = getValFromEnum(typeEnum);

const typeOrderEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
const orderTypesAll: SelectObject[] = getValFromEnum(typeOrderEnum);

const OrderStatusValues = OrderEnum ? OrderEnum.getEnum('OrderStatus') : {};
const valuesOrderStatus: SelectObject[] = getValFromEnum(OrderStatusValues);

//const orderTypes: SelectObject[] = orderTypesAll.filter((itp) => itp.value != 4);

const completedFilterValues: SelectObject[] = [
    {
        label: 'yes',
        value: 1,
    },
    {
        label: 'no',
        value: 2,
    },
];

const getColumns = (
    dataStud: SelectObject[],
    districts: SelectObject[],
    vendors: SelectObject[],
    serviceTypes: SelectObject[],
): Column<IOrderRemainingHoursReport>[] => [
    {
        Header: 'Order',
        accessor: 'id',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) => {
            if (original.totalRow) {
                return <b>Total</b>;
            }
            if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
                return <Link to={Router.generate(routes.ORDER_DETAIL, { id: original.id })}>{original.id}</Link>;
            } else {
                return original.id;
            }
        },
        Filter: textFilter<IOrderRemainingHoursReport>(),
    },
    {
        Header: 'Valid to',
        accessor: 'caseNumberValidityTo[before]',
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrder>) => {
            const date = original.caseNumberValidityTo ? original.caseNumberValidityTo.split('T')[0] : '';
            return changeToZeroMoment(date, 'MMM D, YYYY');
        },
        disableSortBy: true,
        Filter: dateFilter<IOrderRemainingHoursReport>(),
    },
    {
        Header: 'Order Name',
        accessor: 'name',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) => {
            return original.name;
        },
        Filter: textFilter<IOrderRemainingHoursReport>(),
    },
    {
        Header: 'Order Type',
        accessor: 'orderType',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueOrderType = orderTypesAll.find((it) => it.value === original.orderType);
            return valueOrderType ? valueOrderType.label : '';
        },
        Filter: dropDownFilter<IOrder>(orderTypesAll),
    },
    {
        Header: 'Case Number',
        accessor: 'caseNumber',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) => original.caseNumber,
        Filter: textFilter<IOrderRemainingHoursReport>(),
    },
    {
        Header: 'Student',
        accessor: 'student.lastName',

        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) =>
            original.student ? `${original.student?.firstName} ${original.student?.lastName}` : null,
        Filter: textFilter<IOrderRemainingHoursReport>('text', 500, 'Last name'),
    },
    {
        Header: 'Service',
        accessor: 'serviceType',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) => {
            const labelArr = [];
            if (original?.serviceType?.title) {
                labelArr.push(original.serviceType.title);
            }
            if (original?.serviceType?.cpt) {
                labelArr.push(`CPT: [${original.serviceType.cpt}]`);
            }
            const label = labelArr.join(', ');
            return label;
        },
        Filter: dropDownFilter<IOrderRemainingHoursReport>(serviceTypes, styles.minWidth),
    },
    {
        Header: 'Recently used orders',
        accessor: 'recentOrders',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) => {
            const valueCaseCompleted = completedFilterValues.find((it) => {
                return it.value == original.recentOrders;
            });
            return valueCaseCompleted ? valueCaseCompleted.label : '';
        },
        disableSortBy: true,
        Filter: dropdownFilter<IOrderRemainingHoursReport>(completedFilterValues, styles.minWidth),
    },
    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrder>) => {
            const valueStatus = valuesOrderStatus.find((it) => it.value === original.status);
            return valueStatus ? valueStatus.label : null;
        },
        Filter: dropdownOrderFilter<IOrderRemainingHoursReport>(valuesOrderStatus),
    },
    {
        Header: 'External rate',
        accessor: 'externalRate',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) =>
            original.externalRate ? `${numberWithCommas(original.externalRate)}` : null,
    },
    {
        Header: 'Future income',
        accessor: 'futureIncome',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) =>
            original.futureIncome ? `${numberWithCommas(original.futureIncome)}` : null,
    },
    {
        Header: 'Amount Of Remaining Hours',
        accessor: 'amountOfRemainingHours',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) =>
            original.amountOfRemainingHours ? `${numberWithCommas(original.amountOfRemainingHours)}` : null,
    },
    {
        Header: 'Approximately Month Left',
        accessor: 'monthLeftOfRemainingHours',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IOrderRemainingHoursReport>) =>
            original.monthLeftOfRemainingHours ? `${numberWithCommas(original.monthLeftOfRemainingHours)}` : null,
    },
];

const OrderRemainingHoursReportsGrid: React.FunctionComponent<Props> = ({
    data,
    getData,
    getDataCsv,
    students,
    districts,
    vendors,
    serviceTypes,
}: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (students.length && !columns.length && serviceTypes.length) {
        setColumns(getColumns(students, districts, vendors, serviceTypes));
    }

    return (
        <div className={classNames(styles.grid)}>
            <Grid<IOrderRemainingHoursReport> getDataCsv={getDataCsv} columns={columns} data={data} getData={getData} />
        </div>
    );
};

export default OrderRemainingHoursReportsGrid;
